// "Healed" never matches fixed (archived) anomalies, so turning Show Fixed on
// resets that review status to All instead of showing an always-empty list.
export const filtersOnArchivedToggle = (filters, archived) => (
  archived && filters.review_status === 'healed' ? { ...filters, review_status: '' } : filters
);
